import { CommonModule } from '@angular/common';
import { Inject, NgModule } from '@angular/core';
import { GraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { WebAngularSharedUtilErrorHandlingModule } from '@content-platform/web-angular-shared-util-error-handling';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { APPLICATION_API_OPTIONS, ApplicationApiConstants } from './application-api-config';
import { ApplicationEffects, RoleEffects, UserPermissionListEffects, UserRoleListEffects } from './effects';
import { guards } from './guards';
import { ActiveApplicationLoggingTransformer, AppReportParamsTransformer, UserRolesLoggingTransformer } from './transformers';
import { fromApplication, fromRole, fromUserPermissionList, fromUserRoleList } from './reducers';
import { resources } from './services';
import { ApiParams } from './services/api-params';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import * as i0 from "@angular/core";
const moduleErrorMessage = 'App Name not defined with WebAngularSharedDataAccessApplicationApiModule import. ' +
    'Expected: WebAngularSharedDataAccessApplicationApiModule.forRoot(<AppName>)';
export function aplicationApiOptFactory(appName) {
    return {
        appName: appName,
        production: Configuration.isProductionEquivalentEnvironment()
    };
}
/**
 * Registers the application state & reducer, and also adds in the
 * {@link ApplicationEffects } service.
 *
 */
export class WebAngularSharedDataAccessApplicationApiModule {
    // injecting as we can't set it inside the withApp function, get this error otherwise:
    // ERROR in Error during template compile of 'AppModule'
    // Function calls are not supported in decorators but 'WebAngularSharedDataAccessApplicationApiModule' was called.
    constructor(options) {
        // enforce the use of withApp for the module import
        ApplicationApiConstants.activeAppName = options.appName;
        ApplicationApiConstants.production = options.production;
        if (!ApplicationApiConstants.activeAppName) {
            throw new SyntaxError(moduleErrorMessage);
        }
    }
    static forRoot(appName) {
        return {
            ngModule: WebAngularSharedDataAccessApplicationApiModule,
            providers: [
                { provide: 'app-name', useValue: appName },
                {
                    provide: APPLICATION_API_OPTIONS,
                    useFactory: aplicationApiOptFactory,
                    deps: ['app-name']
                }
            ]
        };
    }
    static { this.ɵfac = function WebAngularSharedDataAccessApplicationApiModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WebAngularSharedDataAccessApplicationApiModule)(i0.ɵɵinject(APPLICATION_API_OPTIONS)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: WebAngularSharedDataAccessApplicationApiModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [ApiParams, ...resources, guards], imports: [CommonModule,
            GraphApiModule,
            StoreModule.forFeature('application', fromApplication.reducer),
            StoreModule.forFeature('role', fromRole.reducer),
            StoreModule.forFeature('userRoleList', fromUserRoleList.reducer),
            StoreModule.forFeature('userPermissionList', fromUserPermissionList.reducer),
            EffectsModule.forFeature([
                ApplicationEffects,
                RoleEffects,
                UserRoleListEffects,
                UserPermissionListEffects
            ]),
            LoggingModule.withExtraParams([
                ActiveApplicationLoggingTransformer,
                UserRolesLoggingTransformer
            ]),
            WebAngularSharedUtilErrorHandlingModule.withExtraParams(AppReportParamsTransformer)] }); }
}
//# sourceMappingURL=web-angular-shared-data-access-application-api.module.js.map